import { buildQueries, queryAllByLabelText } from '@testing-library/react'

const getAllSelect = (container: HTMLElement) => {
  return Array.from(
    container.querySelectorAll<HTMLElement>('.react-select__control')
  )
}

/**
 * By Placeholder
 */
const queryAllSelectByPlaceholderText = (
  container: HTMLElement,
  placeholderText
): HTMLElement[] => {
  const selectPlaceholders = container.querySelectorAll(
    '.react-select__placeholder'
  )
  const matchedPlaceholders = Array.from(selectPlaceholders).filter(
    (placeholderElem) => {
      return placeholderElem.textContent.match(placeholderText)?.length
    }
  )

  return matchedPlaceholders.map((match) =>
    match.closest('.react-select__control')
  )
}

const getPlaceholderMultipleError = (c, queryText) =>
  `Found multiple Select with the placeholder of: ${queryText}`

const getPlaceholderMissingError = (c, queryText) =>
  `Unable to find a Select with the placeholder of: ${queryText}`

const [
  querySelectByPlaceholderText,
  getAllSelectByPlaceholderText,
  getSelectByPlaceholderText,
  findAllSelectByPlaceholderText,
  findSelectByPlaceholderText,
] = buildQueries(
  queryAllSelectByPlaceholderText,
  getPlaceholderMultipleError,
  getPlaceholderMissingError
)

/**
 * By Label
 */

const queryAllSelectByLabelText = (container: HTMLElement, labelText) => {
  return queryAllByLabelText(container, labelText)
    .map((el) => el.closest<HTMLElement>('.react-select__control'))
    .filter((el) => el !== null)
}

const getLabelTextMultipleError = (c, queryText) =>
  `Found multiple Select with the label of: ${queryText}`

const getLabelTextMissingError = (c, queryText) =>
  `Unable to find a Select with the label of: ${queryText}`

const [
  querySelectByLabelText,
  getAllSelectByLabelText,
  getSelectByLabelText,
  findAllSelectByLabelText,
  findSelectByLabelText,
] = buildQueries(
  queryAllSelectByLabelText,
  getLabelTextMultipleError,
  getLabelTextMissingError
)

/**
 * By Display Value
 */

export const queryAllSelectByDisplayValue = (
  container: HTMLElement,
  displayValue
) => {
  return getAllSelect(container).filter((el) => {
    const singleValue = el.querySelector<HTMLElement>(
      '.react-select__single-value'
    )
    return singleValue && singleValue.textContent === displayValue
  })
}

const getDisplayValueMultipleError = (c, queryText) =>
  `Found multiple Select with the display value of: ${queryText}`

const getDisplayValueMissingError = (c, queryText) =>
  `Unable to find a Select with the display value of: ${queryText}`

const [
  querySelectByDisplayValue,
  getAllSelectByDisplayValue,
  getSelectByDisplayValue,
  findAllSelectByDisplayValue,
  findSelectByDisplayValue,
] = buildQueries(
  queryAllSelectByDisplayValue,
  getDisplayValueMultipleError,
  getDisplayValueMissingError
)

/**
 * By ID
 */

export const queryAllSelectById = (container: HTMLElement, id) => {
  return Array.from(
    container.querySelectorAll<HTMLElement>(`#${id} .react-select__control`)
  )
}

const getIdMultipleError = (c, queryText) =>
  `Found multiple Select with the id of: ${queryText}`

const getIdMissingError = (c, queryText) =>
  `Unable to find a Select with the id of: ${queryText}`

const [
  querySelectById,
  getAllSelectById,
  getSelectById,
  findAllSelectById,
  findSelectById,
] = buildQueries(queryAllSelectById, getIdMultipleError, getIdMissingError)

export {
  querySelectByPlaceholderText,
  getAllSelectByPlaceholderText,
  queryAllSelectByPlaceholderText,
  getSelectByPlaceholderText,
  findAllSelectByPlaceholderText,
  findSelectByPlaceholderText,
  querySelectByLabelText,
  getAllSelectByLabelText,
  getSelectByLabelText,
  findAllSelectByLabelText,
  findSelectByLabelText,
  querySelectByDisplayValue,
  getAllSelectByDisplayValue,
  getSelectByDisplayValue,
  findAllSelectByDisplayValue,
  findSelectByDisplayValue,
  querySelectById,
  getAllSelectById,
  getSelectById,
  findAllSelectById,
  findSelectById,
}
